import Hash from './helpers/handleHash'

const Model = {
  setState(data) {
    Hash.setHash(Hash.encodeHash(data))
  },
  getState() {
    const data = Hash.parseHash(Hash.getHash())
    return data
  }
}

export default Model



// WEBPACK FOOTER //
// ./src/Model.js